import { render, staticRenderFns } from "./projectSo.vue?vue&type=template&id=0314305d&"
import script from "./projectSo.vue?vue&type=script&lang=js&"
export * from "./projectSo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports